/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { Input, InputAdornment, Box } from "@mui/material";
import { ReactComponent as TableSearchIcon } from "assets/images/icons/table-search.svg";
import Dropdown from "./dropdown";
import SimpliCityAdminSDK from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";

const MUNICIPALITY_LIST_KEY = "four_muni_list";

const SearchFilterBar = (props) => {
    const { token } = useAuth();
    const handleSearchInputChange = props?.onSearchInputChange;
    const handleSearchTrigger = props?.onSearchTrigger;
    const handleMunicipalityChange = props?.onMunicipalityChange;
    const currentSearchInput = props?.searchInput;
    const currentSelectedMunicipality = props?.selectedMunicipality;

    const [municipalityOptions, setMunicipalityOptions] = useState([]);

    useEffect(() => {
        const fetchMunicipalityOptions = async () => {
            const response = await SimpliCityAdminSDK.list.findOneByKey(token, MUNICIPALITY_LIST_KEY);
            const options = [
                {
                    value: "All municipalities",
                    label: "All municipalities"
                }
            ];
            for (const option of response) {
                options.push({
                    value: option,
                    label: option
                });
            }
            setMunicipalityOptions(options);
        };
        fetchMunicipalityOptions();
    }, [token]);
    
    const handleSearchFieldChange = (event) => {
        const inputValue = event?.target?.value || "";
        if (handleSearchInputChange) {
            handleSearchInputChange(inputValue);
        }
    };
    
    const handleSearchFieldKeyPress = (event) => {
        if (event.key === "Enter") {
            if (handleSearchTrigger) {
                handleSearchTrigger();
            }
        }
    };
    
    const handleSearchIconClick = () => {
        if (handleSearchTrigger) {
            handleSearchTrigger();
        }
    };
    
    const handleMunicipalityDropdownChange = (event) => {
        const selectedValue = event?.target?.value || "All municipalities";
        if (handleMunicipalityChange) {
            handleMunicipalityChange(selectedValue);
        }
        handleSearchTrigger();
    };
    
    return (
        <div className="simplicity-search-filter-bar">
            <div className="simplicity-search-filter-dropdown">
                <Dropdown 
                    width="100%"
                    value={currentSelectedMunicipality}
                    onChange={handleMunicipalityDropdownChange}
                    options={municipalityOptions}
                    // currentValue={currentSelectedMunicipality}
                />
            </div>
            <div className="simplicity-search-filter-input">
                <Input 
                    className="search-input"
                    placeholder="Search for a ticket number, disputant..."
                    value={currentSearchInput}
                    onChange={handleSearchFieldChange}
                    onKeyPress={handleSearchFieldKeyPress}
                    // inputProps={{ disableUnderline: true }}
                    endAdornment={
                        <InputAdornment position="end">
                            <Box 
                                component={TableSearchIcon}
                                className="search-icon"
                                onClick={handleSearchIconClick}
                            />
                        </InputAdornment>
                    }
                />
            </div>
        </div>
    );
};

SearchFilterBar.displayName = "SearchFilterBar";
export { SearchFilterBar };
